<template>
  <v-row v-if="homepage && $vuetify.breakpoint.smAndUp">
    <v-col>
      <ObjectImages
        :images="computedHotImages"
        :img-folder="'objectImages/large'"
      />
    </v-col>
  </v-row>
</template>

<script>
import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
import sharedComputed from '@/methods/sharedComputed'
import ObjectImages from '@/components/ObjectImages/ObjectImages'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'HomeDesktopImagesSlider',

  components: {
    ObjectImages,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    computedHotImages() {
      return this.hotImages
        .filter((ad) => ad.objectImages && ad.objectImages[0] && ad.visible)
        .map((ad) => {
          const image = ad.objectImages[0]
          image.objectInfo = ad
          image.linkToObject = true
          return image
        })
    },
  },
}
</script>
